<div class="archive-box" [@archiveBox] *ngIf="archiveService.items.length">
  <div class="archive-box-header">
    <div class="header-text">
      <h3 *ngIf="lastItem?.completed">
        Download<ng-container *ngIf="archiveService.items.length !== 1">s</ng-container> Ready
      </h3>
      <h3 *ngIf="!lastItem?.completed && lastItem?.archive.status === 'resizing'">
        Resizing ZIP-File<ng-container *ngIf="archiveService.items.length !== 1">s</ng-container>
      </h3>
      <h3 *ngIf="!lastItem?.completed && lastItem?.archive.status !== 'resizing'">
        Generating ZIP-File<ng-container *ngIf="archiveService.items.length !== 1">s</ng-container>
      </h3>
      <div class="size">{{ totalSize | dataUnits : 0 }}</div>
    </div>

    <button
      appButton
      name="toggle-open"
      location="archive-download-info"
      [iconButton]="true"
      color="simple-gray"
      (click)="minimized = !minimized"
    >
      <app-svg src="/assets/icons/chevron-collapse.svg" *ngIf="!minimized"></app-svg>
      <app-svg src="/assets/icons/chevron-expand.svg" *ngIf="minimized"></app-svg>
    </button>

    <button
      appButton
      name="close"
      location="archive-download-info"
      [iconButton]="true"
      color="simple-gray"
      (click)="archiveService.cancelAll()"
    >
      <app-svg src="/assets/icons/cross.svg"></app-svg>
    </button>
  </div>

  <div class="archive-body" *ngIf="!minimized" [@archiveBody]>
    <div class="archive-box-item" *ngFor="let item of archiveService.items">
      <div class="archive-info">
        <b [appTooltip]="item.archive.zip_name + '.zip'">{{ item.archive.zip_name }}.zip</b>
        <p *ngIf="item.completed && !item.downloaded">Ready · {{ item.archive.total_size | dataUnits : 0 }}</p>
        <p *ngIf="item.downloaded">Done</p>
        <p *ngIf="item.errored">Error</p>
        <ng-container *ngIf="!item.completed && !item.errored">
          <p *ngIf="item.archive.status === 'resizing'">Resizing...</p>
          <p *ngIf="item.archive.status !== 'resizing'">Generating...</p>
        </ng-container>
      </div>

      <div class="indicator">
        <ng-container *ngIf="!item.completed && !item.errored">
          <app-circle-progress-bar *ngIf="item.progress" [progress]="item.progress" [size]="32" [strokeWidth]="12">
          </app-circle-progress-bar>
          <app-loading-indicator *ngIf="!item.progress" stroke="3" [size]="'32'"></app-loading-indicator>
        </ng-container>

        <button
          appButton
          name="download"
          location="archive-download-info"
          color="primary"
          shape="round"
          height="1"
          size="1"
          (click)="archiveService.downloadArchive(item)"
          *ngIf="item.completed && !item.downloaded"
        >
          Download
        </button>

        <div class="check-container" *ngIf="item.downloaded">
          <app-svg src="/assets/icons/check.svg"></app-svg>
        </div>
      </div>
    </div>
  </div>
</div>
